<template>
  <div class="dd-spinner" :style="styleVars" aria-label="loading" role="status"></div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    size: { type: Number, default: 36 },
    thickness: { type: Number, default: 3 },
  },
  computed: {
    styleVars() {
      return {
        width: this.size + 'px',
        height: this.size + 'px',
        borderWidth: this.thickness + 'px',
      };
    }
  }
}
</script>

<style scoped>
.dd-spinner {
  border-radius: 50%;
  border-style: solid;
  border-color: rgba(0,0,0,0.1);
  border-top-color: var(--dd-accent);
  animation: ddspin 0.8s linear infinite;
  margin: 16px auto;
}
@keyframes ddspin { to { transform: rotate(360deg); } }
</style>

